<script lang="ts">
  // libs
  import Flash from "@shared/services/flashv2.js";
  import { humanizeList } from "@retailer/helpers";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // components
  import NotificationPayBanner from "@retailer/svelte/Payments/Banners/NotificationPay.svelte";
  import ReactivationBanner from "@retailer/svelte/Payments/Banners/Reactivation.svelte";
  import SuspensionBanner from "@retailer/svelte/Payments/Banners/Suspended.svelte";
  import DisabledBanner from "@retailer/svelte/Payments/Banners/Disabled.svelte";
  import ComingSoonBanner from "@retailer/svelte/Payments/Banners/ComingSoon.svelte";

  // services
  import * as UserNotificationsService from "@retailer/services/user_notifications_service";

  // stores
  import { userNotifications } from "@retailer/stores/UserNotificationsStore";
  import { userDisabled, userReactivated } from "@retailer/svelte/stores/DwollaIdentityStore";
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";
  import { SuspensionStore } from "@retailer/stores/SuspensionStore";

  // data
  const notificationPayBannerType = "notification_pay_banner";
  const comingSoonBannerType = "coming_soon_banner";

  // functions
  // user notification logic
  const handleNotificationPayBannerEnabled = async type => {
    showNotificationPayBanner = false;
    Flash.now({
      type: "success",
      header: "You have successfully turned on notifications",
      message: "You will receive an email when you have a new outstanding invoice.",
    });
    await UserNotificationsService.enableInvoiceNotifications();
    await createUserNotification(type);
  };
  const createUserNotification = async type => {
    const data = {
      user_notification: {
        notification_type: type,
        seen_at: new Date(),
        retailer_id: window["$rootScope"].currentRetailerId,
      },
    };

    return await UserNotificationsService.create(data);
  };
  const handleBannerClose = async type => {
    switch (type) {
      case notificationPayBannerType:
        showNotificationPayBanner = false;
        break;
      case comingSoonBannerType:
        showComingSoonBanner = false;
        break;
    }
    await createUserNotification(type);
  };
  const userNotificationSeen = type =>
    $userNotifications.seen.find(n => n.notification_type == type);

  const suspendedFrom = $SuspensionStore.suspensions
    ? humanizeList("and")([
        ...new Set($SuspensionStore.suspensions.map(suspension => suspension.distributor.name)),
      ])
    : null;

  // reactives
  $: showLoadingState = !$InvoiceStore.loaded || !$SuspensionStore.loaded;
  $: showBannerBaselineConditional =
    !$userNotifications.loading && $InvoiceStore.counts.paid == 0 && !showLoadingState;
  $: showNotificationPayBanner =
    !userNotificationSeen(notificationPayBannerType) &&
    $InvoiceStore.counts.unpaid == 0 &&
    showBannerBaselineConditional;
  $: showComingSoonBanner =
    !userNotificationSeen(comingSoonBannerType) && showBannerBaselineConditional;
  $: specsReadOnly = stagedRolloutCheck("specs_read_only_payments");
  $: suspendedFromProvipay = $SuspensionStore.suspensions.length > 0;

</script>

{#if suspendedFromProvipay}
  <SuspensionBanner {suspendedFrom} />
{:else if specsReadOnly}
  {#if showComingSoonBanner}
    <ComingSoonBanner {handleBannerClose} />
  {/if}
{:else if $userDisabled}
  <DisabledBanner />
{:else if $userReactivated}
  <ReactivationBanner />
{:else if showNotificationPayBanner}
  <NotificationPayBanner {handleNotificationPayBannerEnabled} {handleBannerClose} />
{/if}
